<app-grouped-datatable
  class="campaign-details-observations-table"
  [style.display]="groupedMode() ? null : 'none'"
  [groups]="groupedMode() ? groupedRowData() : []"
  [totalParentCount]="groupedMode() ? groupedRowData().length : 0"
  [parentColumns]="groupedParentColumns()"
  [childColumns]="groupedChildColumns()"
  [customParentColumnDef]="groupedParentCustomColumns()"
  [customChildColumnDef]="groupedChildCustomColumns()"
  [configurationInput]="groupedConfiguration()"
  [isInitialDataLoaded]="!loading()"
  [loadingData]="loading()"
  [loaderConfig]="groupedSkeletonLoaderConfig"
  [currentTab]="currentTab"
  (childRowClick)="onGroupedChildRowClicked($event.child)"
/>

<app-datatable
  class="campaign-details-observations-table"
  [style.display]="groupedMode() ? 'none' : null"
  [columns]="columns"
  [configurationInput]="configuration()"
  [customColumnDef]="customColumns()"
  [loaderConfig]="skeletonLoaderConfig"
  [isInitialDataLoaded]="!loading()"
  [loadingData]="loading()"
  [rowData]="groupedMode() ? [] : rowData()"
  [total]="groupedMode() ? 0 : rowData().length"
  (rowClick)="rowClicked.emit($event.row)"
/>

<ng-template #statusColumn let-row="row">
  <app-status-badge [colorScheme]="row.rowStatusColorScheme" [status]="row.rowStatus" />
</ng-template>

<ng-template #observationColumn let-row="row">
  <span
    class="line-clamp-1 text-ellipsis"
    matTooltip
    matTooltipPosition="above"
    [appTextClampTooltip]="row.deliverableName"
  >
    {{ row.deliverableName }}
  </span>
</ng-template>

<ng-template #groupedObservationColumn let-row="row">
  <span
    class="line-clamp-1 text-ellipsis"
    matTooltip
    matTooltipPosition="above"
    [appTextClampTooltip]="row.sourceRow.deliverableName"
  >
    {{ row.sourceRow.deliverableName }}
  </span>
</ng-template>

<ng-template #groupedChildIndicatorColumn>
  <div class="flex items-center justify-center">
    <app-icon src="/icons/corner-down-right.svg" alt="Observation" [size]="14" />
  </div>
</ng-template>

<ng-template #creatorColumn let-row="row">
  <div class="flex min-w-0 items-center gap-2">
    <app-icon-badge
      backgroundColor="var(--shikenso-base-white)"
      fallbackBackgroundColor="var(--shikenso-gray-base)"
      [borderRadius]="100"
      [content]="row.creatorIcon"
      [fallbackText]="row.creatorName"
      [fontSize]="12"
      [iconSize]="24"
      [size]="24"
    />
    <span
      class="line-clamp-1 text-ellipsis"
      matTooltip
      matTooltipPosition="above"
      [appTextClampTooltip]="row.creatorName"
    >
      {{ row.creatorName }}
    </span>
  </div>
</ng-template>

<ng-template #observationsCountColumn let-row="row">
  <span>{{ row.observationsCount }}</span>
</ng-template>

<ng-template #dateColumn let-row="row">
  <div class="flex items-center gap-2">
    <app-icon src="/icons/calendar-event.svg" alt="Calendar" [size]="16" />
    <span>{{ row.dateLabel || '-' }}</span>
  </div>
</ng-template>
